type StatusProps = {
  msg: string;
};

const Status = ({ msg }: StatusProps) => {
  return <p className="error-status">{msg}</p>;
};

export default Status;
